import Vue from "vue";
import get from "lodash/get";
import Notification from "./Notification";

Vue.component("CustomNotification", Notification);

class Notifier {
  constructor() {
    this.emitter = new Vue();
  }
  emit(message, type, options = {}) {
    this.emitter.$emit("globalNotifcations", Object.assign({}, options, { type, message }));
  }
  success(message, options = {}) {
    this.emit(message, "success", options);
  }
  error(message, options = {}) {
    this.emit(message, "error", options);
  }
  errorFromResponse(error, options = {}) {
    let message =
      get(error, "response.data.message", get(error, "response.message")) || "Something went wrong";
    // in case it is an exception, it comes with actual error message in the error field
    const err = get(error, "response.data.error", get(error, "response.error"));
    // if that error was given then we use it instead
    if (err) {
      message = err;
    }
    this.error(message, options);
  }
  info(message, options = {}) {
    this.emit(message, "info", options);
  }
  warning(message, options = {}) {
    this.emit(message, "warning", options);
  }
}

window.Notify = new Notifier();
